import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const Row = ({ v, codes, onDone }) => {
  const [reason, setReason] = useState("");
  const [code, setCode] = useState("other");
  const act = (action) => api.post(`/ott/admin/videos/${v.video_id}/decision`, { action, reason, reason_code: action === "approve" ? null : code })
    .then(() => { toast.success(`Done: ${action}`); onDone(); })
    .catch((e) => toast.error(e.response?.data?.detail || "Failed"));
  return (
    <div className="border border-stone-200 rounded-2xl p-3 bg-white" data-testid={`ott-mod-${v.video_id}`}>
      <div className="flex flex-wrap justify-between gap-2">
        <Link to={`/ott/watch/${v.video_id}`} className="font-black text-stone-900 hover:underline">{v.title}</Link>
        <span className="text-[10px] font-black uppercase bg-amber-100 text-amber-800 rounded-full px-2 py-0.5">{v.status.replace("_", " ")}</span>
      </div>
      <div className="text-xs text-stone-500">{v.creator_name} · {v.kind === "link" ? v.external?.provider : `${v.duration_s}s upload`} · {v.category}{v.review_reasons?.length ? ` · ${v.review_reasons.join(", ").replaceAll("_", " ")}` : ""}</div>
      {v.reports.map((r) => (
        <div key={r.report_id} className="text-xs mt-1 text-red-700" data-testid={`ott-mod-report-${r.report_id}`}>
          {r.kind === "copyright" ? `Copyright claim by ${r.claimant_name} <${r.claimant_email}> · original: ${r.original_work_url}` : "Abuse report"} — {r.reason}
        </div>
      ))}
      <div className="flex flex-wrap gap-2 mt-2 items-center">
        <select value={code} onChange={(e) => setCode(e.target.value)} className="border border-stone-200 rounded-xl px-2 py-1 text-xs" data-testid={`ott-mod-code-${v.video_id}`}>
          {codes.map((c) => <option key={c} value={c}>{c.replaceAll("_", " ")}</option>)}
        </select>
        <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required except approve)" className="flex-1 min-w-[180px] border border-stone-200 rounded-xl px-2 py-1 text-xs" data-testid={`ott-mod-reason-${v.video_id}`} />
        <button onClick={() => act("approve")} className="text-xs font-bold bg-emerald-600 text-white rounded-full px-3 py-1" data-testid={`ott-mod-approve-${v.video_id}`}>Approve</button>
        {v.status === "pending_review" && <button onClick={() => act("reject")} className="text-xs font-bold bg-stone-700 text-white rounded-full px-3 py-1" data-testid={`ott-mod-reject-${v.video_id}`}>Reject</button>}
        <button onClick={() => act("takedown")} className="text-xs font-bold bg-red-600 text-white rounded-full px-3 py-1" data-testid={`ott-mod-takedown-${v.video_id}`}>Take down</button>
      </div>
    </div>
  );
};

export const OttModerationPanel = () => {
  const [q, setQ] = useState(null);
  const [cat, setCat] = useState("");
  const load = useCallback(() => api.get("/ott/admin/queue", { params: { category: cat } }).then((r) => setQ(r.data)).catch(() => setQ({ videos: [], error: true })), [cat]);
  useEffect(() => { load(); }, [load]);
  if (!q) return <div className="text-sm text-stone-500">Loading…</div>;
  return (
    <div className="space-y-2" data-testid="ott-moderation-panel">
      <select value={cat} onChange={(e) => setCat(e.target.value)} className="border border-stone-200 rounded-xl px-2 py-1 text-xs" data-testid="ott-mod-category-filter">
        <option value="">All categories</option>
        {(q.categories || []).map((c) => <option key={c} value={c}>{q.category_labels?.[c] || c}</option>)}
      </select>
      {q.error && <div className="text-sm text-red-700">Could not load the moderation queue.</div>}
      {!q.videos.length && !q.error && <div className="text-sm text-stone-500" data-testid="ott-mod-empty">Nothing waiting for review.</div>}
      {q.videos.map((v) => <Row key={v.video_id} v={v} codes={q.reason_codes || ["other"]} onDone={load} />)}
    </div>
  );
};
